import { faBell, faCog } from "@fortawesome/pro-light-svg-icons";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

import { pazienHistory } from "common/components/pazienHistory";
import { GET_NOTIFICATIONS, MARK_NOTIFICATION_READ } from "common/actions/snapshots";

import { NotificationsRedux } from "merchant/features/alerts2/snapshots/notifications";
import "merchant/features/alerts2/snapshots/notifications.scss";

import { PanelIcon, HeaderActions, NotificationPopup, PanelHeader, Title, ManageIcon } from "./notificationPopup";
import { PopupActions } from "./popup_actions";

const viewAll = () => pazienHistory.navigateWithParams("alerts2/inbox", { trigger: true });
const manage = () => pazienHistory.navigateWithParams("alerts2/subscriptions", { trigger: true });

export function AlertsPopup({ onVisibilityChange }) {
    const notificationsData = useSelector((state) => state.snapshots.notifications.data); // TODO: Check eq fn
    const dispatch = useDispatch();
    const ref = useRef();
    const closeMe = () => ref.current.close();
    
    useEffect(() => {
        dispatch(GET_NOTIFICATIONS);
    }, [dispatch]);
    
    const clearAll = () => dispatch(MARK_NOTIFICATION_READ("all", false));
    const hasItems = notificationsData.some((n) => n.read === false);
    return (
        <NotificationPopup
            ref={ref}
            icon={faBell}
            iconStyle="alerts"
            title="Alerts"
            hasIndicator={hasItems}
            onVisibilityChange={onVisibilityChange}
        >
            <div className="alerts2-list">
                <PanelHeader>
                    <Title>Alerts</Title>
                    <HeaderActions>
                        <ManageIcon onClick={manage}><FontAwesomeIcon icon={faCog} /></ManageIcon>
                        <PanelIcon onClick={closeMe}><FontAwesomeIcon icon={faTimes} /></PanelIcon>
                    </HeaderActions>
                </PanelHeader>
                <PopupActions viewAll={viewAll} clearAll={clearAll} hasItems={hasItems} />
                <FullHeightNotifications fromTopBar onlyUnread />
            </div>
        </NotificationPopup>
    );
}

const FullHeightNotifications = styled(NotificationsRedux)`
    .snapshot-notifications-list {
        max-height: calc(100vh - 160px);
    }
`;
